<script>
  import { EventBus } from '../../EventBus'
    export default {
        name: 'Field',
        props: ['fields', 'field', 'preview'],
        data() {
          return {
            visible: false,
            answerOptionIdsTriggers: null,
            selectedAnswerOptionIds: []
          }
        },
        mounted() {
          if (this.preview || !this.field.triggers.length) this.visible = true

          // Stop execution if preview mode
          if (this.preview) return

          this.answerOptionIdsTriggers = this.field.triggers.map(trigger => {
            return trigger.answerOptionId
          })

          EventBus.$on('answerOptionIdClicked', event => {
            if (!this.answerOptionIdsTriggers.length) return

            const parsedEvent = JSON.parse(event)

            if (parsedEvent.newValue == true){
                if (!this.selectedAnswerOptionIds.includes(parsedEvent.answerOptionId)) {
                    this.selectedAnswerOptionIds.push(parsedEvent.answerOptionId)
                }
            } else {
              const idxToRemove = this.selectedAnswerOptionIds.findIndex(answerOptionId => answerOptionId === parsedEvent.answerOptionId)
              if (idxToRemove === -1) return
              this.selectedAnswerOptionIds.splice(idxToRemove, 1)
            }

            const atLeastOneTriggerExists = this.selectedAnswerOptionIds.some(r => {
              return this.answerOptionIdsTriggers.includes(r)
            })

            this.visible = atLeastOneTriggerExists
          })
        },
        computed: {
            totalSelected: function () {
                return this.field.answerOptions.filter(answer => answer.selected === true).length
            }
        }
    }
</script>
<style>
    .field-selection-container {
        width: 100%;
        margin: 10px 0;
    }
    input {
        min-height: 30px;
    }
    .error {
        width: 100%;
        color: red;
    }
</style>
